/* Keep the mobile purchase panel reachable; desktop always shows the full stack. */
(() => {
 function init(scope = document) {
  scope.querySelectorAll('media-gallery[data-desktop-layout="stacked"]').forEach(gallery => {
   const button = gallery.querySelector('[data-sf-stack-expand]');
   if (!button || gallery.dataset.stackReady) return;
   gallery.dataset.stackReady = 'true';
   const items = [...gallery.querySelectorAll('.product__media-list > .product__media-item')];
   const mobile = matchMedia('(max-width: 749px)');
   const controller = new AbortController();
   let expanded = false;
   const sync = () => {
    items.forEach((item, index) => { item.hidden = mobile.matches && !expanded && index > 0; });
    button.hidden = !mobile.matches;
    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = expanded ? 'Show fewer images' : `Show all ${items.length} images`;
   };
   button.addEventListener('click', () => { if (expanded) window.pauseAllMedia?.(); expanded = !expanded; sync(); }, { signal: controller.signal });
   mobile.addEventListener('change', sync, { signal: controller.signal });
   document.addEventListener('shopify:section:unload', event => {
    if (event.target.contains(gallery)) controller.abort();
   }, { signal: controller.signal });
   sync();
  });
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
 document.addEventListener('shopify:section:load', event => init(event.target));
})();
